import { render, staticRenderFns } from "./LeaderBoardList.vue?vue&type=template&id=c43d17f4&"
import script from "./LeaderBoardList.vue?vue&type=script&lang=js&"
export * from "./LeaderBoardList.vue?vue&type=script&lang=js&"
import style0 from "./LeaderBoardList.vue?vue&type=style&index=0&id=c43d17f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports